import axios from "axios";
import store from "@/store";
import FileSaver from "file-saver";

// const homeUrl = '//dev.asket.ru/GitLkApi/public/lkDev'
const homeUrl = "//lc.stone-xxi.ru/api_v2/GitLkApi/public/lk";

const controller = new AbortController();

const getApi = async (url, params) => {
  return await axios({
    method: "get",
    url: homeUrl + url,
    params: params,
    headers: {
      "Content-Type": "application/json",
    },
    signal: controller.signal,
    withCredentials: true,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response.status === 403) {
        store.commit("main/setRoot", false);
        return error.response.data;
      }
    });
};

const postApi = async (url, data) => {
  return await axios({
    method: "post",
    url: homeUrl + url,
    data: data,
    headers: {
      "Content-Type": "application/json",
    },
    signal: controller.signal,
    withCredentials: true,
  })
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      }
    })
    .catch((error) => {
      if (error.response.status === 403) {
        store.commit("main/setRoot", false);
        return error.response.data;
      }
    });
};

const postUrl = async (url, data) => {
  return await axios({
    method: "post",
    url: url,
    data: data,
    headers: {
      "Content-Type": "application/json",
    },
    // withCredentials: true
  }).then((response) => {
    return response.data;
  });
};

const downloadApi = async (url, params, btn, progress) => {
  return await axios({
    method: "get",
    url: homeUrl + url,
    params: params,
    headers: {
      "Content-Type": "application/json",
    },
    signal: controller.signal,
    withCredentials: true,
    responseType: "blob",
    onDownloadProgress: (response) => {
      progress(btn, Math.ceil(response.progress * 100));
    },
  })
    .then(async (response) => {
      if (response.headers["content-type"] === "application/json") {
        return await response.data.text();
      } else if (response.data !== "" && response.status === 200) {
        // let filename = response.headers['content-disposition'].split('filename=')[1].replace(/['"«»]/g, '')
        // let filenameParts = filename.split('.');
        // let extension = filenameParts.pop();

        // // Собираем обратно, добавляя расширение если оно было
        // if (extension && filenameParts.length > 0 && params.customName) {
        //     filename = `${params.customName}.${extension}`;
        // }

        let filename =
          response.headers["content-disposition"]
            ?.split("filename=")[1]
            ?.replace(/['"«»]/g, "") || "download";

        // Разбиваем на части
        let filenameParts = filename.split(".");
        let extension = filenameParts.length > 1 ? filenameParts.pop() : null;

        // Если расширения нет — пробуем взять из content-type
        if (!extension) {
          const mimeType = response.headers["content-type"];
          const defaultExt = mimeType.split("/")[1]; // например, "application/pdf" -> "pdf"
          extension = defaultExt || "bin";
        }

        // Собираем имя файла
        if (params.customName) {
          filename = `${params.customName}.${extension}`;
        } else if (!filename.includes(".")) {
          filename = `${filename}.${extension}`;
        }

        let blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        FileSaver.saveAs(blob, filename);
        return { status: true };
      } else {
        return await response.data.text();
      }
    })
    .catch((error) => {
      if (error.response.status === 403) {
        store.commit("main/setRoot", false);
        return error.response.data;
      }
    });
};

const uploadApi = async (url, data, btn, progress) => {
  return await axios({
    method: "post",
    url: homeUrl + url,
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: (response) => {
      progress(btn, Math.floor(response.progress * 99));
    },
    signal: controller.signal,
    withCredentials: true,
  })
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      }
    })
    .catch((error) => {
      if (error.response.status === 403) {
        // store.commit('main/setRoot', false)
        // return error.response.data
      }
    });
};

const dateMask = (value) => {
  const date = new Date(value);
  return date && value
    ? ("0" + date.getDate()).slice(-2) +
    "." +
    ("0" + (date.getMonth() + 1)).slice(-2) +
    "." +
    date.getFullYear()
    : "Дата не указана";
};

const moneyMask = (value, currency = "₽") => {
    const strValue = String(value).trim().replace(",", ".");
    const num = Number(strValue);

    if (isNaN(num)) return `0.00 ${currency}`;

    // Форматируем число с разделением тысяч и 2 знаками после запятой
    const formatted = num
        .toLocaleString("ru-RU", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })
        .replace(",", "."); // Меняем запятую на точку, если хочешь именно 0.00

    return `${formatted} ${currency}`;
};

const moneySrtToNumber = (value) => {
  return Number(value);
};


const downloadBase64FilePdf = async (base64, name) => {
  // Создаем Blob из base64
  const byteCharacters = atob(base64);
  const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: "application/pdf" });

  // Создаем ссылку и симулируем клик
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = name + ".pdf"; // Название скачиваемого файла
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href); // Освобождаем память
};


export {
  getApi,
  postApi,
  postUrl,
  downloadApi,
  uploadApi,
  dateMask,
  moneyMask,
  moneySrtToNumber,
  downloadBase64FilePdf
};
